class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUpEscape.bind(this));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    if (this.dataset.open == 'hover') {
      this.toggleOnHover();
    }
  }

  toggleOnHover() {
    let closeTimeout;

    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      this.open();
    });

    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => this.close(), 200);
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    const inputSelect = this.querySelector('.product-form__input-select');
    if (inputSelect) inputSelect.style.height = 'auto'; // Reset height of inner element when closed
  }

  onKeyUpEscape(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class DetailsOptions extends DetailsDisclosure {
  constructor() {
    super();
    document.addEventListener('mousedown', this.onDocumentClick.bind(this));

    this.closeButton = this.querySelector('.details__close');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
    }

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    // Adjust height when the element opens
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.adjustHeight();
    }
  }

  adjustHeight() {
    const inputSelect = this.querySelector('.product-form__input-select');
    if (!inputSelect) return; // Exit if the target element isn't found

    const viewportHeight = window.innerHeight;
    const rect = inputSelect.getBoundingClientRect();
    const distanceToBottom = viewportHeight - rect.top;

    // Calculate height as distance to bottom minus 50px, ensuring it doesn't reach the viewport bottom
    let calculatedHeight = distanceToBottom - 50;

    if (calculatedHeight > 0) {
      inputSelect.style.height = `${calculatedHeight}px`;
    } else {
      inputSelect.style.height = 'auto';
    }

    // Add an alert if the height is below 100px
    if (calculatedHeight < 100) {
      inputSelect.classList.add('alert');
    } else {
      inputSelect.classList.remove('alert');
    }
  }

  onFocusOut() {
    // Override with empty to prevent default close on focus out in this class
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  onCloseButtonClick() {
    this.close();
  }
}

customElements.define('details-options', DetailsOptions);